import {
  Box,
  Button,
  CircularProgress,
  Container,
  Pagination,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { useEffect } from 'react';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import SearchIcon from '@mui/icons-material/Search';
import Success from '../../images/undraw/undraw_completed_tasks_vs6q.svg';
import ServerDown from '../../images/undraw/undraw_server_down_s-4-lk.svg';
import ReConfirm from '../../images/undraw/undraw_confirmation_re_b6q5.svg';
import CummonTable from '../../Common/CummonTable';
import FetchLoading from '../../Loading/FetchLoading';
import { createMRTColumnHelper } from 'material-react-table';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2564b8',
      darker: '#2564b8',
    },
  },
});
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: '#fff',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  outline: 'none',
};

const AdminNotice = () => {
  const columnHelper = createMRTColumnHelper();
  const navigate = useNavigate();
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo?.token;
  const [updateNotice, setUpdateNotice] = useState({});
  const columns = [
    columnHelper.accessor('notice', {
      header: 'Notice',
    }),
    columnHelper.accessor('created_at', {
      header: 'Create Time',
    }),

    columnHelper.accessor('operation', {
      header: 'Operation',
      Cell: ({ row }) => (
        <DeleteIcon
          style={{
            color: 'tomato',
            fontSize: '22px',
            cursor: 'pointer',
          }}
          onClick={() => noticeDeleted(row.original?.uid)}
        />
      ),
    }),
  ];
  const [search, setSearch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [allNotice, setAllNotice] = useState([]);
  const [notice, setNotice] = useState([]);
  // todo: pagination handle
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  let size = 20;

  useEffect(() => {
    setIsLoading(true);
    fetch(`https://api-b2b.businesssolutions.ae/agent/notice/all`)
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        setAllNotice(data);
        setNotice(data);
        setPageCount(Math.ceil(data?.length / size));
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
        Swal.fire({
          imageUrl: ServerDown,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          title: 'Failed! to Fetch',
          confirmButtonColor: 'var(--primary-color)',
          confirmButtonText: 'Try Another Time',
        }).then(() => {
          setIsLoading(false);
          navigate('/dashboard');
        });
      });
  }, [refetch]);

  const handlePageChange = (event, value) => {
    setPage(value);
    setSearch(allNotice.slice((value - 1) * size, value * size));
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleUpdateData = (e) => {
    setUpdateNotice({
      ...updateNotice,
      [e.target.name]: e.target.value,
    });
  };

  const noticeDeleted = (id) => {
    const url = `https://api-b2b.businesssolutions.ae/admin/notice/${id}`;

    Swal.fire({
      imageUrl: ReConfirm,
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
      title: 'You want to delete this notice?',
      showCancelButton: true,
      confirmButtonColor: 'red',
      confirmButtonText: 'Delete',
      cancelButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancel',
    }).then(async (willDelete) => {
      if (willDelete.isConfirmed) {
        try {
          const response = await fetch(url, {
            method: 'DELETE',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.ok) {
            Swal.fire({
              imageUrl: Success,
              imageWidth: 400,
              imageHeight: 200,
              imageAlt: 'Custom image',
              title: 'Notice Deleted!',
              confirmButtonColor: 'var(--primary-color)',
              confirmButtonText: 'Ok',
            }).then(() => {
              setRefetch(!refetch);
            });
          } else {
            throw new Error('Failed to delete notice');
          }
        } catch (err) {
          console.error(err);
          Swal.fire({
            imageUrl: ServerDown,
            imageWidth: 400,
            imageHeight: 200,
            imageAlt: 'Custom image',
            title: 'Failed!',
            confirmButtonColor: 'var(--primary-color)',
            confirmButtonText: 'Try Another Time',
          }).then(() => {
            setRefetch(!refetch);
          });
        }
      }
    });
  };

  const handelSearchItems = (e) => {
    let searchInput = e.target.value;
    if (searchInput !== '') {
      const filterData = allNotice.filter((item) => {
        return Object.values(item)
          .join('')
          .toLowerCase()
          .includes(searchInput.toLowerCase());
      });
      setNotice(filterData);
    } else if (searchInput === '') {
      setNotice(allNotice);
    }
  };

  return (
    <Box>
      <AdminHeader />
      <Container>
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '24px',
                color: 'var(--mateBlack)',
              }}
            >
              Notices
            </Typography>

            <Button
              onClick={() => navigate('/dashboard/addnotice')}
              style={{
                color: '#fff',
                background: 'var(--secondary-color)',
                padding: '5px 20px',
                borderRadius: '4px',
                fontSize: '14px',
                textTransform: 'capitalize',
              }}
            >
              Add Notice
            </Button>
          </Box>

          <Box
            sx={{
              boxSizing: 'border-box',
            }}
          >
            {!isLoading ? (
              <CummonTable data={notice} columns={columns} pageSize={15} />
            ) : (
              <FetchLoading />
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AdminNotice;
